import { create } from 'zustand'

/** Le serveur répond-il ? Tenu à jour par l'intercepteur axios (src/lib/api.ts)
 * sur chaque réponse ; lu par le bandeau « Callizy ne répond pas ». */
interface ConnexionState {
  injoignable: boolean
  setInjoignable: (v: boolean) => void
}

export const useConnexionStore = create<ConnexionState>((set) => ({
  injoignable: false,
  setInjoignable: (v) => set((s) => (s.injoignable === v ? s : { injoignable: v })),
}))
